<ng-container [formGroup]="form">
  <div class="form-group" [hidden]="getTargetMarketRows?.disabled">
    <h3>{{ labels.targetMarket.targetMarket }}</h3>
    <div formArrayName="targetMarkets" [hidden]="getTargetMarketRows?.disabled">
      <div
        *ngFor="
          let fee of getTargetMarketRows?.controls;
          let i = index;
          let last = last;
          let first = first
        "
      >
        <div class="form-row align-items-end" [formGroupName]="i">
          <ng-container *ngIf="getTargetMarketRows?.at(i) as row">
            <div
              class="form-group col-lg-2"
              *ngIf="row.get('clientType')"
              [hidden]="row.get('clientType').disabled"
            >
              <app-dc-select
                [label]="!i ? labels.targetMarket.clientType : null"
                [items]="clientTypeItems"
                formControlName="clientType"
                closeOnSelect="true"
                [clearSelection]="true"
                [searchable]="true"
              ></app-dc-select>
            </div>
            <div
              class="form-group col-lg-2"
              *ngIf="row.get('knowledgeAndExperience')"
              [hidden]="row.get('knowledgeAndExperience').disabled"
            >
              <app-dc-select
                [label]="!i ? labels.targetMarket.knowledgeAndExperience : null"
                [items]="knowledgeAndExperienceItems"
                formControlName="knowledgeAndExperience"
                closeOnSelect="true"
                [clearSelection]="true"
                [searchable]="true"
              ></app-dc-select>
            </div>
            <div
              class="form-group col-lg-3"
              *ngIf="row.get('distributionStrategy')"
              [hidden]="row.get('distributionStrategy').disabled"
            >
              <app-dc-select
                [label]="!i ? labels.targetMarket.distributionStrategy : null"
                [items]="distributionStrategyItems"
                formControlName="distributionStrategy"
                closeOnSelect="true"
                [clearSelection]="true"
                [searchable]="true"
              ></app-dc-select>
            </div>
            <app-dc-plus-minus
              *ngIf="!row.get('clientType').readOnly"
              [showPlus]="!i ? first === last : last"
              (minusClick)="deleteTargetMarketRow(i)"
              (plusClick)="addTargetMarketRow()"
            ></app-dc-plus-minus>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-container formGroupName="feesGroup">
    <div class="form-group" [hidden]="form.get('feesGroup')?.disabled">
      <h3>{{ labels.feesGroup.feesGroup }}</h3>
      <div
        formArrayName="feesArr"
        [hidden]="form.get('feesGroup')?.get('feesArr')?.disabled"
      >
        <div
          *ngFor="
            let fee of getFeesRow.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <div class="form-row align-items-end" [formGroupName]="i">
            <ng-container
              *ngIf="form.get('feesGroup')?.get('feesArr').at(i) as group"
            >
              <ng-container *ngIf="i === 0">
                <div
                  class="form-group col-lg-2"
                  *ngIf="getFeesRow.at(0).get('feeType')"
                  [hidden]="getFeesRow.at(0).get('feeType').disabled"
                >
                  <app-dc-select
                    [label]="labels.feesGroup.feeType"
                    [items]="feeTypeItems"
                    orderBy="id"
                    formControlName="feeType"
                    closeOnSelect="true"
                    [clearSelection]="true"
                    [searchable]="true"
                  ></app-dc-select>
                </div>
                <div
                  class="form-group col-lg-2"
                  *ngIf="getFeesRow.at(0).get('currencyFee')"
                  [hidden]="getFeesRow.at(0).get('currencyFee').disabled"
                >
                  <app-dc-select
                    [label]="labels.feesGroup.currencyFee"
                    [items]="currencyItems"
                    closeOnSelect="true"
                    searchable="true"
                    formControlName="currencyFee"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
                <div
                  class="form-group col-lg-2"
                  *ngIf="getFeesRow.at(0).get('amountFee')"
                  [hidden]="getFeesRow.at(0).get('amountFee').disabled"
                >
                  <app-dc-input-number-percent-indicative-final
                    [label]="labels.feesGroup.amountFee"
                    [id]="'amountFee'"
                    formControlName="amountFee"
                    defaultUnit="pct"
                    [readonly]="!canUserEdit"
                  >
                  </app-dc-input-number-percent-indicative-final>
                </div>
                <app-dc-plus-minus
                  *ngIf="!group.get('currencyFee').readOnly"
                  (minusClick)="deleteRow(i)"
                  (plusClick)="addRow()"
                  [showPlus]="first === last"
                ></app-dc-plus-minus>
              </ng-container>
              <ng-container *ngIf="i > 0">
                <div
                  class="form-group col-lg-2"
                  *ngIf="getFeesRow.at(0).get('feeType')"
                  [hidden]="getFeesRow.at(0).get('feeType').disabled"
                >
                  <app-dc-select
                    [items]="feeTypeItems"
                    formControlName="feeType"
                    closeOnSelect="true"
                    [clearSelection]="true"
                    [searchable]="true"
                  ></app-dc-select>
                </div>
                <div
                  class="form-group col-lg-2"
                  *ngIf="getFeesRow.at(0).get('currencyFee')"
                  [hidden]="getFeesRow.at(0).get('currencyFee').disabled"
                >
                  <app-dc-select
                    [items]="currencyItems"
                    closeOnSelect="true"
                    searchable="true"
                    formControlName="currencyFee"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
                <div
                  class="form-group col-lg-2"
                  *ngIf="getFeesRow.at(0).get('amountFee')"
                  [hidden]="getFeesRow.at(0).get('amountFee').disabled"
                >
                  <app-dc-input-number-percent-indicative-final
                    [id]="'amountFee'"
                    formControlName="amountFee"
                    defaultUnit="pct"
                  >
                  </app-dc-input-number-percent-indicative-final>
                </div>
                <app-dc-plus-minus
                  (minusClick)="deleteRow(i)"
                  (plusClick)="addRow()"
                  *ngIf="!group.get('currencyFee').readOnly"
                  [showPlus]="last"
                ></app-dc-plus-minus>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-group">
    <h3>{{ labels.salesRegion }}</h3>
    <div class="form-row">
      <div
        *ngIf="this.form.get('salesRegion') as salesRegion"
        class="form-group col-lg-2"
        [hidden]="salesRegion.disabled"
      >
        <app-dc-select
          [label]="labels.salesRegion"
          [items]="salesRegionItems"
          formControlName="salesRegion"
          closeOnSelect="true"
        ></app-dc-select>
      </div>
    </div>
  </div>

  <div class="form-group">
    <h3>{{ labels.contactInformation.contactInformation }}</h3>
    <div
      formArrayName="contactInformation"
      [hidden]="getContactInformationRows?.disabled"
    >
      <div
        *ngFor="
          let contactRow of getContactInformationRows?.controls;
          let i = index;
          let last = last;
          let first = first
        "
      >
        <div class="form-row align-items-end" [formGroupName]="i">
          <div class="form-group col-lg-2">
            <app-dc-select
              id="deskIdSelector"
              [label]="labels.contactInformation.desk | multilineLabel: i"
              [items]="deskItems$ | async"
              formControlName="deskId"
              closeOnSelect="true"
              [searchable]="true"
              [notFoundText]="noDesksMessage"
              (selected)="onDeskSelected(i)"
            ></app-dc-select>
          </div>
          <div class="form-group col-lg-2">
            <app-dc-select
              [label]="labels.contactInformation.name | multilineLabel: i"
              [items]="
                allContactItems$
                  | async
                  | filterContacts
                    : contactRow.get('deskId').value
                    : getContactInformationRows.value
                    : i
              "
              formControlName="contactId"
              closeOnSelect="true"
              [clearSelection]="true"
              [searchable]="true"
              (selected)="onContactSelected($event, i)"
            ></app-dc-select>
          </div>
          <div class="form-group col-lg-2">
            <app-dc-input
              [label]="
                labels.contactInformation.email | multilineLabel: i
              "
              formControlName="email"
              [readonly]="true"
            ></app-dc-input>
          </div>
          <div class="form-group col-lg-2">
            <app-dc-input
              [label]="
                labels.contactInformation.location | multilineLabel: i
              "
              formControlName="location"
              [readonly]="true"
            ></app-dc-input>
          </div>
          <div class="form-group col-lg-3">
            <app-dc-select
              formControlName="contactInformation"
              [items]="contactInfoItems"
              [clearInputX]="true"
              [closeOnSelect]="true"
              [label]="labels.contactInformation.contactInformation | multilineLabel: i"
            ></app-dc-select>
          </div>
          <app-dc-plus-minus
            *ngIf="!getContactInformationRows?.at(i).readOnly && canUserEdit"
            [showPlus]="last"
            (minusClick)="deleteContactInformationRow(i)"
            (plusClick)="addContactInformationRow()"
          ></app-dc-plus-minus>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group" formGroupName="secondaryMarketAndDataPublising">
    <h3>Secondary Market and Data Publishing</h3>
    <div class="form-row">
      <div class="form-group col-2">
        <app-dc-select
          [label]="labels.salesSecondaryMktRequired"
          [items]="YES_NO"
          formControlName="salesSecondaryMktRequired"
          closeOnSelect="true"
        ></app-dc-select>
      </div>
      <div
        class="form-group col-lg-2"
        [hidden]="!secondaryMktRequired.value"
        [clearOnHide]="true"
        [hiddenControl]="secondaryMktQuotationType"
      >
        <app-dc-select
          [label]="labels.others.secondaryMktQuotationType"
          [items]="secondaryMktQuotationTypeItems"
          [formControl]="secondaryMktQuotationType"
          closeOnSelect="true"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div class="form-group col-2">
        <app-dc-select
          [label]="labels.salesTelekursSetUp"
          [items]="YES_NO"
          formControlName="salesTelekursSetUp"
          closeOnSelect="true"
        ></app-dc-select>
      </div>
    </div>
  </div>

  <ng-container formGroupName="targetMarket">
    <div class="form-group">
      <h3>{{ labels.others.others }}</h3>
      <div class="form-row">
        <div
          *ngIf="
            targetMarket.get('summaryRiskIndicator') as summaryRiskIndicator
          "
          class="form-group col-lg-2"
          [hidden]="summaryRiskIndicator.disabled"
        >
          <app-dc-input
            [label]="labels.targetMarket.summaryRiskIndicator"
            [id]="'summaryRiskIndicator'"
            type="text"
            formControlName="summaryRiskIndicator"
            [readonly]="summaryRiskIndicator.readOnly"
          ></app-dc-input>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-row">
    <div
      *ngIf="this.form.get('esgThematics') as esgThematics"
      class="form-group col-lg-2"
      [hidden]="esgThematics.disabled"
    >
      <app-dc-select
        [label]="labels.others.esgThematics"
        [items]="esgThematicsItems"
        formControlName="esgThematics"
        closeOnSelect="true"
        [clearSelection]="true"
        [multiple]="true"
        [checkbox]="true"
      ></app-dc-select>
    </div>
  </div>
</ng-container>
